import Vue from 'vue'

import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required, email, min, max } from 'vee-validate/dist/rules'
import ValidationInput from '../components/ValidationInput'
import ValidationSelect from '../components/ValidationSelect'

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

extend('required', {
  ...required,
  message: 'Ce champs est requis'
})

extend('email', {
  ...email,
  message: 'L\'email saisi n\'est pas conforme'
})

extend('min', {
  ...min,
  params: ['length'],
  message: 'Ce champs doit faire au moins {length} caractères'
})

extend('max', {
  ...max,
  params: ['length'],
  message: 'Ce champs doit faire moins de {length} caractères'
})
Vue.component('ValidationInput', ValidationInput)
Vue.component('ValidationSelect', ValidationSelect)
